export default {
  location: [],
  sideMenuId: null,
  loadingCount: 0,
  isSidebarCollapsed: window.localStorage.getItem('isSidebarCollapsed') === 'true' || false,
  isSidebarHidden: false,
  isContentsHidden: false,
  ignoreResetLoading: false,
  systemMessage: {
    show: false,
    message: null,
    color: null,
    timeout: -1,
    light: false,
    global: false,
  },
}
